const STORAGE_KEY = 'safeguardpro_audit_v1';

export default class StudentAuditLogger {
  constructor() {
    this.cache = null;
  }

  load() {
    if (this.cache) return this.cache;
    const stored = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
    this.cache = stored ? JSON.parse(stored) : {};
    return this.cache;
  }

  persist() {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(this.cache));
    } catch (error) {
      if (error && error.name === 'QuotaExceededError') {
        try {
          const trimmed = JSON.parse(JSON.stringify(this.cache));
          // Keep only the last 200 log entries to reduce size.
          Object.keys(trimmed).forEach((key) => {
            trimmed[key] = (trimmed[key] || []).slice(0, 200);
          });
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
          this.cache = trimmed;
          console.warn('Audit log trimmed due to storage quota limits.');
        } catch (secondary) {
          console.error('Unable to persist audit log; storage quota exceeded.', secondary);
        }
      } else {
        throw error;
      }
    }
  }

  log(studentId, action, changes, user) {
    const logs = this.load();
    const entry = {
      id: `log-${Math.random().toString(36).slice(2, 9)}`,
      studentId,
      action,
      changes,
      user: user?.name || 'System',
      role: user?.role || 'System',
      timestamp: new Date().toISOString()
    };
    logs[studentId] = [entry, ...(logs[studentId] || [])];
    this.persist();
    return entry;
  }

  getLogs(studentId) {
    const logs = this.load();
    return logs[studentId] || [];
  }
}
